import { StandoutStaticText } from './types';
import {
  ComponentEditorPickProduct,
  ComponentStandoutTextBlock,
  EnumStandoutTextBlockType,
} from '$/(cms)/_modules/cmsService/types';

export const getEditorPickItem = (
  item?: ComponentStandoutTextBlock['editor_pick_product'],
): ComponentEditorPickProduct | undefined => {
  return item?.product ? item : undefined;
};

export const getHeaderTitle = (
  titleType: EnumStandoutTextBlockType,
  staticText: StandoutStaticText,
): string => {
  switch (titleType) {
    case EnumStandoutTextBlockType.EditorsPick:
      return staticText.standout_editors_pick;
    case EnumStandoutTextBlockType.ExpertPerspective:
      return staticText.standout_perspective;
    case EnumStandoutTextBlockType.Takeaways:
      return staticText.standout_takeaways;
    default:
      return staticText.standout_tips;
  }
};
